import styled, { css } from 'styled-components';

const Select = styled.button`
  width: 100%;
  height: 20px;
  padding: 0 10px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-radius: 20px;
  background: #003765;
  cursor: pointer;
  border: none;

  text-transform: uppercase;
  color: white;
  font-size: 8px;
  line-height: 12px;
  font-family: 'Founders Grotesk Mono', serif;
`;

const SelectMenu = styled.div`
  position: fixed;
  bottom: 0;
  right: 0;
  width: 100%;
  z-index: 2147483649;
  padding: 20px;
  background: #215988;
  border-radius: 10px 10px 0 0;
  min-height: 80px;

  display: flex;
  flex-direction: column;
  row-gap: 10px;

  ${({ open, isMounted, height }) => {
    if (open && isMounted) {
      return css`
        translate: translateY(-${height}px);
      `;
    }
  }}

  ${({ open, isMounted, height }) => {
    if (!open && isMounted) {
      return css`
        translate: translateY(${height}px);
      `;
    }
  }}
`;

const Option = styled.div`
  text-transform: uppercase;
  color: white;
  font-size: 14px;
  font-family: 'Founders Grotesk Mono', serif;
  height: 40px;
  cursor: pointer;
  position: relative;

  display: flex;
  justify-content: flex-start;
  align-items: center;

  span {
    margin-left: 20px;
  }

  ${({ selected }) => {
    if (selected) {
      return css`
        &::before {
          content: '';
          width: 4px;
          height: 4px;
          border-radius: 50%;
          background: #00a4af;
          position: absolute;
          left: 0;
          top: 50%;
          transform: translateY(-50%);
        }
      `;
    }
  }}
`;

const OverflowLayout = styled.div`
  background: #001947;
  opacity: 0.5;
  z-index: 2147483647;

  height: 100vh;
  width: 100vw;
  position: fixed;
  top: 0;
`;

const CloseButton = styled.div`
  background: #003765;
  width: 30px;
  height: 30px;
  border-radius: 50%;
  position: absolute;
  cursor: pointer;
  top: 20px;
  right: 20px;

  display: flex;
  justify-content: center;
  align-items: center;
`;

export const S = {
  Select,
  SelectMenu,
  Option,
  OverflowLayout,
  CloseButton,
};
